module.exports = __webpack_public_path__ + "static/media/roboto.9c431a75.fnt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto.fnt
// module id = 373
// module chunks = 0